//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from 'config/index';

const auth = () => {
  async function login(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-login/cdr-employee`, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function customerLogin(values) {
    try {
      const obj = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-login/cdr-customer`, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function verifyEmail(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-signup/cdr-verifyemployeeemail`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function verifyOTP(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-signup/cdr-verifyotp`, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function signupDetails(values, token) {
    try {
      const obj = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-signup/cdr-signup`, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function forgotPassword(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-signup/cdr-forgotpassword`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function resetPassword(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-signup/cdr-resetpassword`, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function createnewadmin(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-signup/cdr-resetpassword/create-admin-reset-password`, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function isLoggedIn(token) {
    try {
      const obj = {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-login/cdr-auth/auth/${token}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function redirection() {
    try {
      const obj = {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-signup/cdr-forgotpassword/get-redirection`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function getRoles(req) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-signup/cdr-signup/get-roles/${req}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function handleDllEncrypt(req) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(req),
      };
      let res = await fetch(
        `${config.host}/cdr-login/dll-handler/encrypt`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function handleDllDecrypt(query) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-login/dll-handler/decrypt?query=${query}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function getAllRoles(req) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-login/cdr-customer/get-roles`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function getEnrollmentStatus(query, gepFlag) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let uri = gepFlag == 'true' ? `${config.host}/cdr-gep/thrive-signup/get-enrollment-status?token=${query}` : `${config.host}/cdr-oneweb/thrive-signup/get-enrollment-status?token=${query}`;
      let res = await fetch(uri, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function customerEnrollment(values, gepFlag) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let uri = gepFlag == 'true' ? `${config.host}/cdr-gep/thrive-signup/enrollment` : `${config.host}/cdr-oneweb/thrive-signup/enrollment`
      let res = await fetch(uri, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function cancelEnrollment(values, gepFlag) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let uri = gepFlag == 'true' ? `${config.host}/cdr-gep/thrive-signup/cancel-enrollment` : `${config.host}/cdr-oneweb/thrive-signup/cancel-enrollment`
      let res = await fetch(uri, obj);
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function getTransferStatus(query) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/get-transfer-status?token=${query}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function oneWebTransfer(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/transfer`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function cancelTransfer(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/cancel-transfer`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function getManualEnrollmentStatus(query,gepFlag) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      
      let url = gepFlag == 'true' ? `${config.host}/cdr-gep/thrive-signup/get-manual-enrollment-status?token=${query}` : `${config.host}/cdr-oneweb/thrive-signup/get-manual-enrollment-status?token=${query}`;
      
      let res = await fetch(
        url,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function manualEnroll(values,gepFlag) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let url = gepFlag == 'true' ?  `${config.host}/cdr-gep/thrive-signup/manual-enrollment` : `${config.host}/cdr-oneweb/thrive-signup/manual-enrollment`;

      let res = await fetch(
       url,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function cancelManualEnrollment(values,gepFlag) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let url = gepFlag == 'true' ?  `${config.host}/cdr-gep/thrive-signup/cancel-manual-enrollment` : `${config.host}/cdr-oneweb/thrive-signup/cancel-manual-enrollment`;

      let res = await fetch(
        url,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  // Manual transfer
  async function getManualTransferStatus(query) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/get-manual-transfer-status?token=${query}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function manualTransfer(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/manual-transfer`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function cancelManualTransfer(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/cancel-manual-transfer`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function membershipUnassigned(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-login/membership-unassigned`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function adminConsentPending(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-login/admin-consent-pending`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function getAdminConsentStatus(query) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/get-admin-consent-status?token=${query}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function verifyAdminConsent(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/verify-admin-consent`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function uploadConsent(values) {
    try {
      const obj = {
        method: 'POST',
        body: values,
      };
      let res = await fetch(
        `${config.host}/cdr-oneweb/thrive-signup/upload-consent`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) { }
  }

  async function downloadConsentForm(type) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      let res = await (
        await fetch(
          `${config.host}/cdr-oneweb/thrive-signup/download-consent-form/${type}`,
          obj
        )
      ).json();

      return res;
    } catch (err) {
      console.log(err);
    }
  }

  async function getDormantAccountStatus(token) {
    try {
      const obj = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      let res = await (
        await fetch(
          `${config.host}/cdr-gep/thrive-signup/dormant-status/${token}`,
          obj
        )
      ).json();

      return res;
    } catch (err) {
      console.log(err);
    }
  }

  async function reactivateDormantAccount(values) {
    try {
      const obj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      };

      let res = await (
        await fetch(
          `${config.host}/cdr-gep/thrive-signup/reactivate-dormant-account`,
          obj
        )
      ).json();

      return res;
    } catch (err) {
      console.log(err);
    }
  }

  return {
    verifyEmail,
    verifyOTP,
    signupDetails,
    login,
    forgotPassword,
    resetPassword,
    createnewadmin,
    customerLogin,
    isLoggedIn,
    getRoles,
    handleDllEncrypt,
    handleDllDecrypt,
    getAllRoles,

    getEnrollmentStatus,
    customerEnrollment,
    cancelEnrollment,

    getManualEnrollmentStatus,
    manualEnroll,
    cancelManualEnrollment,

    getTransferStatus,
    oneWebTransfer,
    cancelTransfer,

    getManualTransferStatus,
    manualTransfer,
    cancelManualTransfer,

    membershipUnassigned,
    adminConsentPending,

    getAdminConsentStatus,
    verifyAdminConsent,
    uploadConsent,
    downloadConsentForm,
    redirection,
    getDormantAccountStatus,
    reactivateDormantAccount
  };
};

export default auth;
